import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg p-6 max-w-md w-full mx-4" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_3 = { class: "text-sm text-gray-900" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-sm text-gray-900" }
const _hoisted_6 = { class: "text-sm text-gray-900" }
const _hoisted_7 = { class: "flex justify-end gap-2 mt-6" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 mb-4" }, "View Details", -1)),
          (_ctx.item)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1" }, "Query", -1)),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.item.query), 1)
                ]),
                (_ctx.programName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1" }, "Program", -1)),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.programName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1" }, "Added on", -1)),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatWatchlistDate(_ctx.item.addedAt)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Update frequency ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFrequency) = $event)),
                    class: "w-full px-3 py-2 border border-gray-300 rounded-md"
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("option", { value: "daily" }, "Daily", -1),
                    _createElementVNode("option", { value: "weekly" }, "Weekly", -1),
                    _createElementVNode("option", { value: "monthly" }, "Monthly", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.localFrequency]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
              class: "px-4 py-2 text-gray-600 hover:text-gray-800"
            }, " Cancel "),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args))),
              disabled: _ctx.saving,
              class: "px-4 py-2 bg-primary-purple text-white rounded-md hover:bg-primary-purple/90 disabled:opacity-50"
            }, _toDisplayString(_ctx.saving ? "Saving..." : "Save"), 9, _hoisted_8)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}